import Image from "next/image";
import ApplePayOption from "@/assets/images/ApplePayOption.png";
import GooglePayOption from "@/assets/images/GooglePayOption.png";
import CreditCardOption from "@/assets/images/CreditCardOption.png";
import AmazonPay from "@/assets/svg/amazon_pay";
import Paypal from "@/assets/svg/Paypal.svg";

const payment_methods = {
  cc: {
    id: "cc",
    label: (
      <div className="items-center flex space-x-2 ">
        <Image src={CreditCardOption} alt="CreditCardOption" height={20} width={40} />
        <span>Credit Card</span>
      </div>
    ),
    checkoutBtnLabel: "Checkout",
  },
  apple_pay: {
    id: "apple_pay",
    name: "Apple Pay",
    link: "https://support.apple.com/en-us/HT201239#stores",
    label: (
      <div className="items-center flex space-x-2">
        <Image src={ApplePayOption} alt="ApplePayOption" height={20} width={40} />
        <span>Apple Pay</span>
      </div>
    ),
    checkoutBtnLabel: "Checkout with Apple Pay",
  },
  google_pay: {
    id: "google_pay",
    name: "Google Pay",
    link: "https://support.google.com/wallet/answer/12059331?hl=en&co=GENIE.Platform=Android&visit_id=638591787903932330-391943986&rd=2",
    label: (
      <div className="items-center flex space-x-2">
        <Image src={GooglePayOption} alt="GooglePayOption" height={20} width={40} />
        <span>Google Pay</span>
      </div>
    ),
    checkoutBtnLabel: "Checkout with Google Pay",
  },
  amazon_pay: {
    id: "amazon_pay",
    name: "Amazon Pay",
    label: (
      <div className="items-center flex space-x-2">
        <div className="mt-2 w-32">
          <AmazonPay alt="AmazonPayOption" width={"180"} height={"180"} />
        </div>
      </div>
    ),
    checkoutBtnLabel: "Checkout with Amazon Pay",
  },
  link: {
    id: "link",
    name: "Link Pay",
    label: (
      <div className="items-center flex space-x-2">
        <div className="mt-2 w-32">Link pay</div>
      </div>
    ),
    checkoutBtnLabel: "Checkout with Link Pay",
  },
  paypal: {
    id: "paypal",
    name: "Paypal",
    label: (
      <div className="items-center flex space-x-2">
        <div className="mt-2 w-32">
          <Paypal alt="AmazonPayOption" width={"75"} height={"23"} />
        </div>
      </div>
    ),
    checkoutBtnLabel: "Checkout with Paypal",
  },
};

export default payment_methods;
